<template>
    <div class="spell-wrap">
        <div class="left-title">
            <div>
                <img src="../../../../assets/img/grammarTest/book.png" alt="">
                <p>语法复习中</p>
            </div>
        </div>
        <div class="content-box">
            <!--强制复习时的提示-->
            <transition name="el-fade-in-linear" mode="out-in">
                <div class="hint-text" v-if="isHint" key="save">
                    <div>回忆刚学的语法，接下来进入拼写强化阶段</div>
                    <div>【提示：要用“投胎”的速度听写哦！】</div>
                    <div style="margin-top:30px;">
                        <el-button type="success" @click="selectOrder(1)">原序拼写</el-button>
                        <el-button type="danger" @click="selectOrder(2)">逆序拼写</el-button>
                    </div>
                </div>
                <!--练习框-->
                <div class="exercise-box spell-box" v-if="showExercise" key="1">
                    <div class="translate">
                        <el-button v-if="!showTranslate" style="background:#2BC3B9;color: #fff "
                                    @click="showTranslate=!showTranslate">词义提示
                        </el-button>
                        <el-button type="danger" v-else @click="showTranslate=!showTranslate" plain>
                            词义隐藏
                        </el-button>
                        <transition name="el-zoom-in-left">
                            <div v-if="showTranslate" class="translate-text">{{spellData.grammar.meaning}}</div>
                        </transition>
                    </div>
                    <div class="issue" v-html="grammarText"></div>
                    <div class="input-box popup-box" v-for="(item,index) in spellAnswer" :key="index">
                        <!--输入框左侧语音按钮-->
                        <div class="input-btn audio-btn">
                            <img v-if="index==0" src="../../../../assets/img/grammarTest/headset.png"
                                    @click="playAudio" alt="">
                            <div v-else style="width: 50px"></div>
                        </div>
                        <audio id="eventAudio" :src="spellData.grammar.voice"
                                v-if="index==0" autoplay></audio>
                        <!--填写答案输入框-->
                        <el-input v-model="spellData['spellInput'+index]" placeholder=""
                                    @keyup.enter.native="nextWord()" @input="checkout(index)"></el-input>
                        <div class="input-btn">
                            <el-button v-if="isNext&&index==0"
                                        type="success"
                                        @click="nextWord()">
                                下一个
                            </el-button>
                            <div class="input-hint-img">
                                <!--错误的情况-->
                                <img class="animated flipInX" v-if="spellData['isCorrect'+index]"
                                        src="@/assets/img/grammarTest/error.png" alt="">
                                <!--正确的情况-->
                                <img class="animated flipInX" v-if="spellData['isError'+index]"
                                        src="@/assets/img/grammarTest/correct.png" alt="">
                            </div>
                        </div>
                    </div>
                    <!--显示答案-->
                    <transition name="el-fade-in" mode="out-in">
                        <div class="error" v-if="showHint||spellData.is_force==1">
                            {{answer}}
                        </div>
                    </transition>
                </div>
            </transition>
        </div>
        <div class="el-message-box__btns" key="edit">
            记忆时间【{{timeNum}}】当前生词【{{saveInfo.err_num||0}}】识别次数【{{saveInfo.num||1}}】
        </div>
    </div>
</template>

<script>
    import Lockr from 'lockr'
    import {mapState, mapGetters, mapMutations} from 'vuex';
    import {getSpell, pushSpell, spellOrder} from "@/api/grammar";


    export default {
        name: "spell",
        props: {
            ShowSpellPop: {},
            dataSource: {},
        },

        data() {
            return {
                spellOrderType: '',//选择的拼写类型
                spellCount: '',//语法总量
                saveInfo: {
                    num: '1',//学习总次数（默认1）
                    state: '1',//类型（默认1）
                },
                grammarText: '',//语法
                grammarIcon: [
                    {img: require('../../../../assets/img/grammarTest/one.png')},
                    {img: require('../../../../assets/img/grammarTest/two.png')},
                    {img: require('../../../../assets/img/grammarTest/three.png')},
                ],
                spellInput: '',//语法输入框
                isHint: true,//是否显示强制复习提示语
                showExercise: false,//是否显示练习框
                showHint: false,//是否显示答案
                isError: false,//是否拼写错误
                isCorrect: false,//是否拼写正确
                showTranslate: false,//是否显示词义提示
                isNext: true,//控制'下一个'按钮的显示
                showResult: false,//显示结果|
                spellData: {},//拼写学习数据
                spellAnswer: '',//答案数量
                timeVal: {
                    hour: 0,
                    minutes: 0,
                    seconds: 0
                },
                timeNum: '',//记忆时间
                secondNum: 0,//只记录秒格式
                clock: '',//倒计时
                totalTime: '20',//倒计时初始时间
                studyTime: 1,//间隔时间
                studyEnd: true,//停止学习
                waiting: false
            };
        },
        methods: {
            ...mapMutations(['CHANGE_STUDY_TYPE']),
            //触发发音
            playAudio() {
                let buttonAudio = document.getElementById('eventAudio');
                buttonAudio.play()
            },
            //选择拼写顺序
            selectOrder(type) {
                this.spellOrderType = type
                let params = {
                    token: Lockr.get('token'),
                    student_id: this.dataSource.studentId,//学员Id
                    orderby: this.spellOrderType
                }
                spellOrder(params).then(res => {
                    this.isHint = false;
                    this.showExercise = true
                    this.spellCount = res.data
                    //记录间隔时间
                    this.recordIntervalTime()
                    this.getSpellData()
                    //开始计时
                    this.timeKeep()
                })
            },
            //获取语法
            getSpellData() {
                this.grammarText = ''
                let params = {
                    token: Lockr.get('token'),
                    student_id: this.dataSource.studentId,//学员Id
                    orderby: this.spellOrderType,
                    count: this.spellCount,
                    num: this.saveInfo.num,
                    state: this.saveInfo.state,
                }
                getSpell(params).then((res) => {
                    this.spellData = res.data
                    this.spellAnswer = res.data.grammar.answer_num
                    this.answer = res.data.grammar.answer.join(',')
                    this.debug_log(this.answer) // 测试
                    for (let i = 0; i < this.spellAnswer; i++) {
                        this.$set(this.spellData, `spellInput${i}`, '')//错误
                    }
                    let grammar = res.data.grammar.subject.split('()')
                    grammar.forEach((item, index) => {
                        this.grammarText += grammar[index]
                        if (index != grammar.length - 1) {
                            this.grammarText += `<span class="fill-in"><img src="${this.grammarIcon[index].img}" alt=""></span>`
                        }
                    })
                    this.countDown(this.spellData.grammar.time)
                    this.playAudio()
                })
            },
            //下一个
            nextWord() {
                // 防止重复点击
                // if (this.waiting) return
                // this.waiting = true
                // 清除倒计时
                this.clock && clearInterval(this.clock)
                this.spellData.grammar.answer.map((item, index) => {
                    if (this.spellData['spellInput' + index] == item) {
                        // 拼写正确的情况
                        this.isNext = false
                        this.studyEnd = true
                        this.$set(this.spellData, `isError${index}`, true)
                        setTimeout(() => {
                            this.$set(this.spellData, `isError${index}`, false)
                            this.isNext = true
                            if (index == this.spellAnswer - 1) {
                                this.pushSpell(1, 'compel')
                            }
                        }, 1500)
                    } else if (this.spellData.is_force == 1) {
                        this.$set(this.spellData, `isCorrect${index}`, true)
                        this.isNext = false
                        this.showHint = true
                        setTimeout(() => {
                            this.$set(this.spellData, `isCorrect${index}`, false)
                            this.isNext = true
                            this.showHint = false
                        }, 2000)
                    } else {
                        // 拼写错误的情况
                        this.$set(this.spellData, `isCorrect${index}`, true)
                        this.isNext = false
                        this.showHint = true
                        setTimeout(() => {
                            this.$set(this.spellData, `isCorrect${index}`, false)
                            this.isNext = true
                            this.showHint = false
                            if (index === this.spellAnswer - 1) this.pushSpell(0)
                        }, 2000)
                    }
                })
            },
            //点击下一个时提交拼写
            pushSpell(isPass, compel = '') {
                if (this.studyEnd) {
                    if (this.spellData.is_force == 1 && compel == '') {
                        //如果本语法要求强制拼写，那么必须输入正确才能提交
                        return
                    }
                    let params = {
                        token: Lockr.get('token'),
                        student_id: this.dataSource.studentId,//学员Id
                        num: this.saveInfo.num,
                        state: this.spellData.state,
                        grammar_id: this.spellData.grammar.grammar_id,
                        count: this.spellCount,
                        study_time: this.studyTime,
                        is_pass: isPass
                    }
                    pushSpell(params).then(res => {
                        if (res.data.is_complete == 1) {
                            this.studyEnd = false
                            let data = {
                                title: '强制复习',
                                type: 'compel/testResult',
                                dataSource: res.data,
                                isStudyEnd: true,
                            }
                            this.CHANGE_STUDY_TYPE(data)
                            return
                        }
                        this.saveInfo = res.data
                        this.getSpellData()
                        this.recordIntervalTime('reset')
                    })
                }

            }
            ,
            // 记录间隔时间
            recordIntervalTime(reset) {
                let timer = setInterval(() => {
                    this.studyTime += 1
                }, 1000)
                if (reset == 'reset') {
                    window.clearInterval(timer)
                    this.studyTime = 0
                }
            },

            //开启记忆时间
            timeKeep() {
                setInterval(this.startTimer, 1000);
            },
            //记忆时间记录器
            startTimer() {
                this.timeVal.seconds += 1;
                this.secondNum += 1
                if (this.timeVal.seconds >= 60) {
                    this.timeVal.seconds = 0;
                    this.timeVal.minutes = this.timeVal.minutes + 1;
                }
                if (this.timeVal.minutes >= 60) {
                    this.timeVal.minutes = 0;
                    this.timeVal.hour = this.timeVal.hour + 1;
                }
                //记忆总时间
                this.timeNum = (this.timeVal.minutes < 10 ? '0' + this.timeVal.minutes : this.timeVal.minutes) + ':' + (this.timeVal.seconds < 10 ? '0' + this.timeVal.seconds : this.timeVal.seconds);
            },
            //倒计时
            countDown(endTime = 20, stop) {
                //每切换一题倒计时重置一遍
                this.clock && clearInterval(this.clock)
                if (stop) return //查看答案时 计时器不执行
                this.totalTime = endTime
                this.clock = window.setInterval(() => {
                    this.totalTime--
                    this.content = this.totalTime
                    if (this.totalTime <= 0) {
                        clearInterval(this.clock)
                        this.nextWord()
                        this.recordIntervalTime('reset')
                        this.totalTime = endTime
                    }
                }, 1000)
            },
            checkout(index) {
                if(this.spellData.is_force==1){
                    let answerInput = this.spellData['spellInput' + index] // aa
                    let answerLen = answerInput.length // 2
                    let answer = this.spellData.grammar.answer[index] // aab
                    let str = answer.substring(0, answerLen)
                    if (str !== answerInput) {
                        let res = this.getAnswerSuccessLength(answer, answerInput)
                        this.spellData['spellInput' + index] = res.join('')
                    }
                }
            },
            getAnswerSuccessLength (answer, str) {
                let arr_answer = answer.split('')
                let arr_str = str.split('')
                let len = arr_answer.length > arr_str.length ? arr_str.length : arr_answer.length
                let res = []
                for (let i = 0; i < len; i++) {
                    if (arr_answer[i] === arr_str[i]) {
                        res.push(arr_answer[i])
                    }
                    if ((arr_answer[i] == ' ' || arr_answer[i] == ' ')  && arr_str[i] == ' ') {
                        res.push(' ')
                    }
                }
                return res
            }
        },
        created() {
        },
    }
</script>

<style lang='less' scoped>
.spell-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    .left-title {
        padding: 10px 0 0 20px;
        height: 40px;
        color: #333;

        > div:nth-of-type(1) {
            display: flex;
            align-items: center;

            p {
                font-size: 18px;
                color: #000;
            }

            img {
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
        }

        .countDown {
            background: url('../../../../assets/img/grammarTest/time_bg.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            width: 50px;
            height: 50px;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .content-box {
        transition: all .5s;
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .hint-text {
            flex: 1;
            position: relative;
            text-align: center;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            > .hint-box {
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 600px;
                height: 160px;
                font-weight: bold;
                box-shadow: 0px 1px 12px 3px rgba(0, 0, 0, 0.08);
            }

            > div:nth-of-type(2) {
                color: #FF626F;
                margin: 5px 0;
            }
        }

        .exercise-box {
            width: 100%;
            box-sizing: border-box;
            padding: 20px 20px 20px 50px;
            flex: 1;
            display: flex;
            flex-direction: column;
            .statement-text {
                font-size: 30px;
                font-weight: 600;
                display: flex;
                align-items: center;
                margin: 20px 0;
                padding-right: 40px;

                > .volume {
                    margin-left: 5px;
                    cursor: pointer;

                    img {
                        width: 26px;
                        height: 26px;
                    }

                    img:hover {
                        opacity: 0.8;
                    }
                }
            }
        }
    }


    /*语法相关*/
    .spell-box {

        .translate {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .translate-text {
                font-size: 21px;
                font-weight: 600;
                margin-left: 30px;
                width: 600px;
            }
        }

        .input-box {
            display: flex;
            align-items: center;
            margin: 12px 0;

            .input-btn {
                margin: 0 20px;
                cursor: pointer;
                transition: all .5s;
                width: 50px;

                .input-hint-img {
                    img {
                        width: 50px;
                        height: 50px;
                    }
                }
            }

            .audio-btn {
                margin-right: 20px;
                cursor: pointer;
                transition: all .5s;
                width: 50px;

                img {
                    width: 50px;
                    height: 50px;
                }
            }

            .audio-btn:hover {
                opacity: .7;
            }
        }

        .issue {
            font-size: 32px;
            color: #FF6600;
            min-height: 50px;

            /deep/ span {
                display: inline-block;
                width: 50px;
                height: 35px;
                margin: 0 5px;
                border-bottom: 1px dashed #979797;

                /deep/ img {
                    display: block;
                    width: 28px;
                    height: 28px;
                    margin: 0 auto;
                }
            }
        }

        .error {
            padding-left: 100px;
            color: #E50114;
            margin-top: 20px;
            font-size: 32px;
            font-weight: 600;
        }
    }

    .result-box {
        display: flex;
        width: 100%;

        .left-box, .right-box {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 18px;
            font-weight: 600;

            .test-info {
                display: flex;
                align-items: center;
                margin: 10px 0;
                justify-content: center;

                img {
                    width: 30px;
                    margin-right: 10px;
                }

                .bad-test {
                    color: #f56c6c;
                }
            }
        }

        .right-box {

            .right-btn {
                margin-top: 30px;
            }
        }
    }
    .el-message-box__btns {
        font-size: 16px;
        color: #333333;
    }
}
</style>